import {ENC} from './decrypt_pwd'

export const redmine = {
  domain: 'https://smee.gapinc.com',
  adminApiKey: ENC('U2FsdGVkX1+HEyD02h8pcKqBHm92dZW/Yd+KfZdBqI+9JmDJEIEPVuaSSpdRpM8LUpOnG76d/FIJkDMyqf1bvg==')
}

export const microservice = {
  domain: '/smee'
}

export const smee = {
  complexServiceUrl: 'https://rpt-search-service-production.apps.cfprod.phx.gaptech.com/rpt-search-service/sourcing/responsive-product-groups/search',
  userName: 'rpt_client',
  passWord: ENC('U2FsdGVkX1+SD0RwpGKaxzVhilHGLgeIiVbDpSHQRPoipNw2QFjYoqePUcI1izQE'),
  sharepoint: {
    vpseFolderId: 'SMEEprod/vpse',
    trmFolderId: 'SMEEprod/trm',
    qasFolderId: 'SMEEprod/qas',
    pclFolderId: 'SMEEprod/pcl',
    wipFolderId: 'SMEEprod/wip',
    mstVendorConnectFolderId: 'SMEEprod/mst',
    commitmentFolderId: 'SMEEprod/commitment'
  }
}

export const redbannerScheduler = {
  redbannerStartTime: '22:00:00',
  redbannerEndTime: '23:59:00'
}

// Below property is added to make no. of universal CC# per page configurable on "Initiate Ad Sample Requests" screen as part of Card No. SMEE-1794
export const rowsPerPageOptions = [20, 50, 100]

// Redirect URL to the new booking application
export const newBookingApplicationUrl = 'https://gisbooking.gapinc.com/'




// WEBPACK FOOTER //
// ./src/app-config.js